<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    style="enable-background: new 0 0 512 512"
    xml:space="preserve"
  >
    <g>
      <g>
        <path
          d="M484.364,139.689c12.255-69.354-34.627-123.64-36.825-126.135L435.6,0L423.66,13.554
			c-2.198,2.496-49.081,56.781-36.825,126.135h-11.019l12.051,138.586v207.208h31.821V512h31.821v-26.518h31.821V278.275
			l12.051-138.586H484.364z M426.445,70.217c2.905-6.988,6.132-13.176,9.171-18.354c11.089,18.896,24.686,51.386,16.253,87.826
			h-32.553C414.129,117.432,416.509,94.116,426.445,70.217z M451.511,453.661h-31.821V293.493h31.821V453.661z M452.833,261.671
			h-34.467l-7.841-90.161h50.148L452.833,261.671z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M16.617,13.464v487.929h328.822V13.464H16.617z M313.618,469.571H48.439V45.285h265.179V469.571z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M80.26,77.107v95.464h201.536V77.107H80.26z M249.975,140.75H112.082v-31.821h137.893V140.75z"
        />
      </g>
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>